import { apiClient } from "@/lib/api-client"
import { HttpStatusCodes } from "@/lib/http-status-codes"
import type {
  SageVipConnectionDto,
  SageVipUpsertRequestDto,
  SageVipUpsertResponseDto,
} from "../dtos/SageVipConnectDto"

export async function getVipConnection(
  organizationId: string | null,
): Promise<SageVipConnectionDto | null> {
  try {
    const response = await apiClient.get<SageVipConnectionDto>(
      `/organizations/${organizationId}/sagevip/connection`,
    )
    return response.data
  } catch (err: unknown) {
    const status =
      (err as { response?: { status?: number } }).response?.status ?? 0
    if (status === HttpStatusCodes.NOT_FOUND) return null
    throw err
  }
}

export async function upsertVipConnection(
  organizationId: string | null,
  dto: SageVipUpsertRequestDto,
): Promise<SageVipUpsertResponseDto> {
  const response = await apiClient.post<SageVipUpsertResponseDto>(
    `/organizations/${organizationId}/sagevip/connection`,
    dto,
  )
  return response.data
}

export async function deleteVipConnection(
  organizationId: string | null,
): Promise<void> {
  await apiClient.delete(`/organizations/${organizationId}/sagevip/connection`)
}

export const sageVipConnectorService = {
  getVipConnection,
  upsertVipConnection,
  deleteVipConnection,
}
